import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Employee } from '@models/employee/employee.model';
import { FeatureFlag } from '@app/enums';
import { FeatureService } from '@app/services/feature.service';

@Component({
    templateUrl: './benefits-show.template.html',
    styleUrls: ['./benefits-show.style.scss'],
})
export class BenefitsShowView implements OnInit {
    isLoading = true;
    employee: Employee;

    showSimplyBenefitsCard = false;

    constructor(
        protected route: ActivatedRoute,
        private featureService: FeatureService
    ) {
        this.employee = this.route.snapshot.data.models.get('employee');
    }

    async ngOnInit(): Promise<void> {
        const simplyBenefitsFlag = await this.featureService.has(FeatureFlag.simplyBenefits);
        this.showSimplyBenefitsCard = !!(simplyBenefitsFlag && this.employee.company?.simplyBenefitsAccountId);
    }
}
